import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddLeadingZerosPipe } from "./add-leading-zeros.pipe";

@NgModule({
  declarations: [
    AddLeadingZerosPipe
  ],
  imports: [
    CommonModule
  ], exports: [
    AddLeadingZerosPipe
  ]
})
export class AddLeadingZerosModule {

  static forRoot() {
    return {
      ngModule: AddLeadingZerosModule,
      providers: [],
    };
  }
}
